module.exports = __webpack_public_path__ + "img/prop-glasses-right.08d718df.png";